(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function() {
  document.querySelectorAll('.nova-product-card__atc:not(.nova-product-card__atc--disabled)').forEach(function(btn) {
    if (btn._novaInit) return;
    btn._novaInit = true;

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalHTML = btn.innerHTML;
      btn.classList.add('nova-product-card__atc--loading');
      btn.innerHTML = '<span>Ajout...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        btn.classList.remove('nova-product-card__atc--loading');
        btn.classList.add('nova-product-card__atc--added');
        btn.innerHTML = '<span>✓ Ajouté</span>';
        window.dispatchEvent(new CustomEvent('cart:updated'));
        return fetch('/cart.js');
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var badge = document.querySelector('.cart-badge');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        setTimeout(function() {
          btn.classList.remove('nova-product-card__atc--added');
          btn.innerHTML = originalHTML;
        }, 2000);
      })
      .catch(function() {
        btn.classList.remove('nova-product-card__atc--loading');
        btn.innerHTML = '<span>Erreur</span>';
        setTimeout(function() { btn.innerHTML = originalHTML; }, 2000);
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
